import { render, staticRenderFns } from "./verifyDetailList.vue?vue&type=template&id=b0e8c0c8&scoped=true&"
import script from "./verifyDetailList.vue?vue&type=script&lang=js&"
export * from "./verifyDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e8c0c8",
  null
  
)

export default component.exports